import { observable, action } from 'mobx';
import parse from 'date-fns/parse';
import pubSub from '../utils/pubSub';
import format from '../utils/format';

export default class DayStore {
  @observable dayModalIsOpen = false;

  @observable activeDay = '';

  @observable activeDayFormatted = '';

  @action
  setActiveDay(activeDay) {
    const parsedDate = parse(activeDay);

    this.activeDay = activeDay;
    this.activeDayFormatted = format(parsedDate, 'dddd D MMMM YYYY').toLowerCase();
  }

  @action
  toggleModal(force, key = 'dayModalIsOpen') {
    if (force === false) {
      pubSub.publish('fetch:employees');
    }

    if (force) {
      this[key] = force;
      return;
    }

    this[key] = !this[key];
  }
}



// WEBPACK FOOTER //
// ./src/store/dayStore.js